<template>
  <div class="counter">
    <div class="counter__button" @click="onMinusClick">-</div>
    <div class="counter__value">{{ props.modelValue }}</div>
    <div class="counter__button" @click="onPlusClick">+</div>
  </div>
</template>

<script setup>
const MIN = 1

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },

  maxMintCount: {
    type: Number,
    default: 100,
  },
})

const emit = defineEmits(['update:modelValue'])

function onMinusClick(event) {
  const value = props.modelValue - 1

  if (value < MIN) {
    return event.preventDefault()
  }

  emit('update:modelValue', value)
}

function onPlusClick(event) {
  const value = props.modelValue + 1

  if (value > props.maxMintCount) {
    return event.preventDefault()
  }

  emit('update:modelValue', value)
}
</script>

<style lang="sass">
.counter
  position: relative
  display: flex
  justify-content: center
  align-items: center
  user-select: none
  background-color: white
  color: black
  padding: 8px
  border: 2px solid #ffe462
  font-size: 34px
  line-height: 30px

  &__button
    cursor: pointer
    font-size: 44px

    &:hover
      opacity: 0.8

  &__value
    text-align: center
    min-width: 120px
    font-weight: 600

</style>